import { DataTable } from "primereact/datatable";
import React, { useRef, useState } from "react";
import Table from "./Table";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
import Form from "./Form";
import { useLocation } from "react-router-dom";
export interface IModel {
  open: boolean;
}

const LegalTaskManagement = (permissions: IPermissionProps) => {
  const location = useLocation();
  const { taskId } = location.state || {};

  console.log(location);

  const [modal, setModal] = useState({ open: false } as IModel);
  const [reload, setReload] = useState(false);
  const toast = useRef<any>(null);
  const hideDialog = () => {
    setModal({ open: false });
  };
  return (
    <>
      <Table permissions={permissions} reload={reload} setModal={setModal} taskId={taskId || 0} toast={toast} />
      <Form open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} loadTableData={() => { }} />
      <Toast ref={toast} />
    </>
  );
};

export default LegalTaskManagement;
